// Shared visual base for compact status pills (border + dot + mono
// uppercase label). Used by components/ui/sold-out-badge.tsx and
// components/account/status-badge.tsx — both size/tone/color decisions
// stay in the caller; this only owns the shared layout.

type PillBadgeSize = "sm" | "md";

const SIZE_PADDING: Record<PillBadgeSize, string> = {
	sm: "px-2.5 py-1",
	md: "px-3 py-[5px]",
};

const SIZE_TEXT: Record<PillBadgeSize, string> = {
	sm: "text-[0.59375rem]",
	md: "text-[0.65625rem]",
};

export function PillBadge({
	label,
	size = "sm",
	borderClassName = "border-[#d8d8d2] bg-transparent",
	dotClassName = "bg-muted",
	textClassName = "text-muted",
	className = "",
}: {
	label: string;
	size?: PillBadgeSize;
	borderClassName?: string;
	dotClassName?: string;
	textClassName?: string;
	className?: string;
}) {
	return (
		<span
			className={`inline-flex items-center gap-2 whitespace-nowrap border ${borderClassName} ${SIZE_PADDING[size]} ${className}`}
		>
			<span className={`h-[7px] w-[7px] rounded-full ${dotClassName}`} />
			<span
				className={`font-mono uppercase tracking-[var(--tracking-mono)] ${textClassName} ${SIZE_TEXT[size]}`}
			>
				{label}
			</span>
		</span>
	);
}
